// Customer-editable contact information only. Contract identity, prices,
// company signature and dates are never accepted through this object.
export const CUSTOMER_FIELD_NAMES = ['signerTitle', 'ownerAddress', 'contractorPhone', 'contractorEmail',
  'billingName', 'billingAddress', 'billingEmail', 'managerName', 'managerPhone', 'managerMobile'];
export function validCustomerFields(fields) {
  const valid = !!fields && typeof fields === 'object' && !Array.isArray(fields)
    && Object.keys(fields).every(key => CUSTOMER_FIELD_NAMES.includes(key)
      && typeof fields[key] === 'string' && fields[key].length <= 1000 && !/[\u0000-\u001f\u007f-\u009f]/.test(fields[key]));
  if (!valid) return false;
  try { return encodeURIComponent(JSON.stringify(fields)).replace(/%[A-F\d]{2}/gi, 'x').length <= 16000; }
  catch { return false; }
}
export function initialCustomerFields(document) {
  const details = document?.contract?.details || {};
  return Object.fromEntries(CUSTOMER_FIELD_NAMES.map(key => [key,
    details[key] || (key === 'contractorEmail' ? document?.signer?.email : '') || '']));
}
export function customerFieldsProblem(fields) {
  const errors = customerFieldErrors(fields);
  if (Object.keys(errors).length) return Object.values(errors)[0];
  if (!validCustomerFields(fields)) return 'Check the highlighted contact fields. Use plain text up to 1,000 characters per field.';
  return '';
}
export function customerFieldErrors(fields) {
  const errors = {};
  for (const key of CUSTOMER_FIELD_NAMES) {
    const value = fields?.[key];
    if (value !== undefined && (typeof value !== 'string' || value.length > 1000 || /[\u0000-\u001f\u007f-\u009f]/.test(value))) {
      errors[key] = 'Use plain text up to 1,000 characters, or leave this field blank if unknown.';
    }
  }
  for (const key of ['contractorEmail', 'billingEmail']) {
    if (!errors[key] && fields?.[key]?.trim() && !/^[^\s@<>;,]+@[^\s@<>;,]+\.[^\s@<>;,]+$/.test(fields[key].trim())) {
      errors[key] = `Enter a valid ${key === 'contractorEmail' ? 'contractor' : 'billing'} email, or leave this field blank if unknown.`;
    }
  }
  return errors;
}
